<h1 mat-dialog-title>Server Connection Lost</h1>
<mat-icon>sync_problem</mat-icon>
<p>
    Please contact support
</p>
<div mat-dialog-actions>
    <a href="/" mat-raised-button color="primary" cdkFocusInitial>Go To Device Menu</a>
</div>
